import { recipe } from "@vanilla-extract/recipes";
import { style } from "@vanilla-extract/css";
import { rem } from "@huub-web/utils/css/rem";

import { transition } from "../../utils/transition";
import { alignVariants } from "../../utils/vanilla/alignVariants";

import { theme } from "../../theme/css/theme.css";

export const chipStyle = recipe({
  base: {
    position: "relative",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    transition: transition(
      "color",
      "outline",
      "background-color",
      "border-color",
    ),
    userSelect: "none",
    borderRadius: rem(999),
    fontWeight: 500,
    overflow: "hidden",
  },
  variants: {
    shrink: {
      true: {
        flexShrink: 1,
      },
      false: {
        flexShrink: 0,
      },
    },
    size: {
      default: {
        height: theme.spacings.m,
        paddingLeft: theme.spacings.xxs,
        paddingRight: theme.spacings.xxs,
      },
      l: {
        height: theme.spacings.l,
        paddingLeft: theme.spacings.xs,
        paddingRight: theme.spacings.xs,
      },
    },
    alignSelf: alignVariants("alignSelf"),
    justifySelf: alignVariants("justifySelf"),
    variant: {
      primary: {
        backgroundColor: theme.colors.primary,
        color: theme.colors.onPrimary,
      },
      secondary: {
        backgroundColor: theme.colors.secondary,
        color: theme.colors.onSecondary,
      },
      gradient: {
        background: `linear-gradient(110deg, ${theme.colors.gradientA} -5%, ${theme.colors.gradientB} 50%, ${theme.colors.gradientC} 105%)`,
        color: theme.colors.onPrimary,
      },
      tertiary: {
        backgroundColor: theme.colors.tertiary,
        color: theme.colors.onTertiary,
      },
      info: {
        backgroundColor: theme.colors.info,
        color: theme.colors.onInfo,
      },
      infoSurface: {
        backgroundColor: theme.colors.infoSurface,
        color: theme.colors.info,
      },
      success: {
        backgroundColor: theme.colors.success,
        color: theme.colors.onSuccess,
      },
      successSurface: {
        backgroundColor: theme.colors.successSurface,
        color: theme.colors.success,
      },
      error: {
        backgroundColor: theme.colors.error,
        color: theme.colors.onError,
      },
      errorSurface: {
        backgroundColor: theme.colors.errorSurface,
        color: theme.colors.error,
      },
      warning: {
        backgroundColor: theme.colors.warning,
        color: theme.colors.onWarning,
      },
      warningSurface: {
        backgroundColor: theme.colors.warningSurface,
        color: theme.colors.warning,
      },
      accent: {
        backgroundColor: theme.colors.primary,
        color: theme.colors.onPrimary,
      },
      currentColor: {
        backgroundColor: "color-mix(in srgb, currentColor 5%, transparent)",
        color: "currentColor",
      },
    },
  },
  defaultVariants: {
    size: "default",
    variant: "secondary",
  },
});

export const edgeContentStyle = style({
  paddingLeft: theme.spacings.xxs,
  paddingRight: theme.spacings.xxs,
});
